(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guarantees"] && !Shopify.designMode) return;
  try {
    // Handle variant update event
  document.addEventListener('variant:update', async (event) => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('view', 'json');
    const variantData = await (await fetch(currentUrl.toString())).json();
    const guaranteeContainer = document.querySelector('.product-guarantee-container');
    if (!guaranteeContainer) return;
    if (variantData.guarantee?.icon && variantData.guarantee?.html) {
      guaranteeContainer.innerHTML = `
        <div class="product-guarantee">
          <div class="product-guarantee__content">
            <div class="product-guarantee__icon">
              <img src="${variantData.guarantee.icon}" alt="Guarantee icon" width="200" height="200">
            </div>
            <div class="product-guarantee__text text-body-base">
              ${variantData.guarantee.html}
            </div>
          </div>
        </div>
      `;
    } else {
      guaranteeContainer.innerHTML = '';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
